export default __webpack_public_path__ + "static/media/awaits.6986dc24.svg";